// cra imports
import React, { lazy, Suspense, useEffect } from 'react';
import reportWebVitals from './reportWebVitals.js';
import { createRoot } from 'react-dom/client';

// import redux requirements
// import html head tags requirements
// import multi language
// import routing modules
// import routes
// import toastify for notification
import 'react-toastify/dist/ReactToastify.css';

// mock server register for demo
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import './styles/main.css';
import { useGetFornitoriRequest } from './api/admin/fornitore/FornitoreApi';
import RootLoader from './components/loading/RootLoader';
import { getLocalStorage } from './localStorage/createPrefixedLocalStorage';
import { initializeAuthentications } from './localStorage/localStorageAuthenticationApi';
import {
    fornitoreFallbackUrlKey,
    fornitoreFaviconLocalStorageKey,
    fornitoreLogoLocalStorageKey,
    fornitoreNomeLocalStorageKey,
    fornitorePermessiLocalStorageKey,
} from './localStorage/fornitoreLocalStorage';

const Main = lazy(() => import('./Main.tsx'));

//const origin = 'http://localhost:5173';



const EntryPoint = () => {
    const { getFornitoriRequest, fornitoriRequest } = useGetFornitoriRequest();

    initializeAuthentications();
    const prefixedStorage = getLocalStorage();
    useEffect(() => {
        getFornitoriRequest()
            .then((response) => {
                if (response && response.data && response.data.styleObject) {
                    updateStyleInCSS(response.data.styleObject);
                }
                prefixedStorage.setItem(
                    fornitoreLogoLocalStorageKey,
                    response.data.logoPath,
                );
                prefixedStorage.setItem(
                    fornitoreFaviconLocalStorageKey,
                    response.data.faviconPath,
                );
                prefixedStorage.setItem(
                    fornitoreNomeLocalStorageKey,
                    response.data.nome,
                );
                if(response.data.fallbackUrl){
                    prefixedStorage.setItem(
                        fornitoreFallbackUrlKey,
                        response.data.fallbackUrl,
                    );
                }

                prefixedStorage.setItem(
                    fornitorePermessiLocalStorageKey,
                    JSON.stringify(response.data.permessi),
                );
            })
            .catch((error) => {
                console.error('Errore la chiamata API:', error);
            });
    }, []);

    const updateStyleInCSS = (newStyle) => {
        if (newStyle !== undefined && newStyle !== null) {
            Object.keys(newStyle).forEach((property) => {
                document.documentElement.style.setProperty(
                    `${property}`,
                    newStyle[property],
                );
            });
        }
    };

    if (fornitoriRequest === undefined) {
        return <RootLoader></RootLoader>;
    }
    return (
        <Suspense fallback={<RootLoader></RootLoader>}>
            <Main></Main>
        </Suspense>
    );
};

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<EntryPoint />);
// ReactDOM.render(<EntryPoint/>, document.getElementById('root'));

serviceWorkerRegistration.register();
/*
 * If you want to start measuring performance in your app, pass a function
 * to log results (for example: reportWebVitals(console.log))
 * or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
 */
reportWebVitals();
